import { 
    DIRECTION,
    POSITION,
    STACK,
    SALARY,
    CURRENCY,
    CITY,
    ONSITE,
    VACANCIES,
 } from "../types";


 export const direction = data => {
    return {
        type: DIRECTION,
        data,
    }
}

export const position = data => {
    return {
        type: POSITION,
        data,
    }
}

export const stack = data => {
    return {
        type: STACK,
        data,
    }
}

export const salary = data => {
    return {
        type: SALARY,
        data,
    }
}

export const currency = data => {
    return {
        type: CURRENCY,
        data,
    }
}

export const city = data => {
    return {
        type: CITY,
        data,
    }
}

export const onsite = data => {
    return {
        type: ONSITE,
        data,
    }
}

export const vacancies = data => {
    return {
        type: VACANCIES,
        data,
    }
}

